import { IconAd, IconAddCalendar, IconAddFollow, IconAddPodcast, IconAddSuggestedSong, IconAddToPlaylist, IconAddToQueue, IconAirPlay, IconAirplayAudio, IconAlbum, IconAlignObjectBottom, IconAlignObjectCenter, IconAlignObjectLeft, IconAlignObjectMiddle, IconAlignObjectRight, IconAlignObjectTop, IconAlignTextCenter, IconAlignTextLeft, IconAlignTextRight, IconApple, IconArrowDown, IconArrowLeft, IconArrowRight, IconArrowTopRight, IconArrowUp, IconArtist, IconArtistActive, IconAttach, IconAudiobook, IconAudiobookAuthor, IconAudioFile, IconAvailableOffline, IconBan, IconBanActive, IconBlock, IconBluetooth, IconBookmark, IconBookmarkActive, IconBriefcase, IconBrowse, IconBrowseActive, IconBusiness, IconCamera, IconCarPlay, IconChartDown, IconChartUp, IconCheck, IconCheckAlt, IconCheckAltFill, IconChevronDown, IconChevronDownAlt, IconChevronDownAltActive, IconChevronLeft, IconChevronLeftAlt, IconChevronRight, IconChevronRightAlt, IconChevronUp, IconChevronUpAlt, IconChromecastConnected, IconChromecastConnectingOne, IconChromecastConnectingThree, IconChromecastConnectingTwo, IconChromecastDisconnected, IconCinemaModeExpand, IconCinemaModeMinimize, IconClear, IconCode, IconCollaborativePlaylist, IconCollection, IconCollectionActive, IconConnectToDevices, IconCopy, IconCopyAlt, IconDelete, IconDestinationPin, IconDeviceArm, IconDeviceCar, IconDeviceCarExit, IconDeviceComputer, IconDeviceMobile, IconDeviceMultispeaker, IconDeviceOther, IconDevices, IconDevicesAlt, IconDeviceSpeaker, IconDeviceTablet, IconDeviceTv, IconDiscover, IconDownload, IconDownloaded, IconDraft, IconDragAndDrop, IconEdit, IconEmail, IconEnhance, IconEnhanceActive, IconEnhanceBadge, IconEvents, IconExclamationAltActive, IconExclamationCircle, IconExternalLink, IconFacebook, IconFacebookMessenger, IconFilter, IconFlag, IconFolder, IconFolderActive, IconFollow, IconFollowActive, IconFullscreen, IconGamesConsole, IconGears, IconGem, IconGithub, IconGoogle, IconGridView, IconGroup, IconGroupActive, IconHash, IconHeadphones, IconHeart, IconHeartActive, IconHelpAltActive, IconHelpCircle, IconHidden, IconHome, IconHomeActive, IconImage, IconInbox, IconInformationAlt, IconInformationAltActive, IconInstagram, IconInvite, IconLab, IconLightning, IconLineMessenger, IconListView, IconLocalFile, IconLocked, IconLockedActive, IconLyrics, IconLyricsActive, IconMakeAvailableOffline, IconMeAlt, IconMeAltActive, IconMenu, IconMessages, IconMic, IconMicActive, IconMicOff, IconMinimize, IconMinus, IconMinusAltActive, IconMix, IconMore, IconMoreAlt, IconMoreAltActive, IconMoreAndroid, IconNewRadio, IconNikePlus, IconNotificationNew, IconNotifications, IconNotificationsActive, IconNowPlaying, IconNowPlayingActive, IconOffline, IconOfflineSync, IconPause, IconPauseAlt, IconPauseAltActive, IconPayment, IconPictureInPicture, IconPin, IconPinActive, IconPlay, IconPlayAlt, IconPlayAltActive, IconPlaybackSpeed0point5x, IconPlaybackSpeed0point8x, IconPlaybackSpeed1point2x, IconPlaybackSpeed1point5x, IconPlaybackSpeed1Point8x, IconPlaybackSpeed1x, IconPlaybackSpeed2Point5x, IconPlaybackSpeed2x, IconPlaybackSpeed3Point5x, IconPlaybackSpeed3x, IconPlaylist, IconPlus, IconPlusAlt, IconPlusAltActive, IconPodcastCreator, IconPodcasts, IconPodcastsActive, IconPower, IconPreview, IconPublic, IconQueue, IconRadio, IconRadioActive, IconRaisedHand, IconReact, IconReceipt, IconRecentlyPlayed, IconRefresh, IconReleased, IconRepeat, IconRepeatOnce, IconReplay, IconReportAbuse, IconRoyalties, IconRoyaltiesActive, IconSearch, IconSearchActive, IconShareAndroid, IconShareIos, IconShuffle, IconSkipBack, IconSkipBack15, IconSkipBackAlt, IconSkipForward, IconSkipForward15, IconSkipForwardAlt, IconSkype, IconSleepTimer, IconSongCredits, IconSort, IconSortBy, IconSortDown, IconSortUp, IconSoundwave, IconSpeechBubble, IconSpotifyConnect, IconSpotifyLogo, IconStar, IconStarAlt, IconStations, IconSubtitles, IconTag, IconTalkSegment, IconTelegram, IconTextBold, IconTextItalic, IconTextUnderline, IconThumbsDown, IconThumbsDownActive, IconThumbsUp, IconThumbsUpActive, IconTiktok, IconTime, IconTimeActive, IconTrack, IconTranslation, IconTranslationActive, IconTrending, IconTrendingActive, IconTrim, IconTumblr, IconTwitter, IconUndo, IconUnlocked, IconUploadAlt, IconUploadAltActive, IconUser, IconUserActive, IconUserCircle, IconVerified, IconVerifiedCheck, IconVerifiedCheckActive, IconVideo, IconVideoVertical, IconVolume, IconVolumeDown, IconVolumeDownActive, IconVolumeOff, IconVolumeOffActive, IconVolumeOneWave, IconVolumeTwoWave, IconVolumeUp, IconVolumeUpActive, IconWatch, IconWatchDownload, IconWhatsApp, IconWifi, IconX, IconXAlt, } from '@spotify-internal/encore-web';
export const icons = {
    IconAd,
    IconAddCalendar,
    IconAddFollow,
    IconAddPodcast,
    IconAddSuggestedSong,
    IconAddToPlaylist,
    IconAddToQueue,
    IconAirPlay,
    IconAirplayAudio,
    IconAlbum,
    IconAlignObjectBottom,
    IconAlignObjectCenter,
    IconAlignObjectLeft,
    IconAlignObjectMiddle,
    IconAlignObjectRight,
    IconAlignObjectTop,
    IconAlignTextCenter,
    IconAlignTextLeft,
    IconAlignTextRight,
    IconApple,
    IconArrowDown,
    IconArrowLeft,
    IconArrowRight,
    IconArrowTopRight,
    IconArrowUp,
    IconArtist,
    IconArtistActive,
    IconAttach,
    IconAudiobook,
    IconAudiobookAuthor,
    IconAudioFile,
    IconAvailableOffline,
    IconBan,
    IconBanActive,
    IconBlock,
    IconBluetooth,
    IconBookmark,
    IconBookmarkActive,
    IconBriefcase,
    IconBrowse,
    IconBrowseActive,
    IconBusiness,
    IconCamera,
    IconCarPlay,
    IconChartDown,
    IconChartUp,
    IconCheck,
    IconCheckAlt,
    IconCheckAltFill,
    IconChevronDown,
    IconChevronDownAlt,
    IconChevronDownAltActive,
    IconChevronLeft,
    IconChevronLeftAlt,
    IconChevronRight,
    IconChevronRightAlt,
    IconChevronUp,
    IconChevronUpAlt,
    IconChromecastConnected,
    IconChromecastConnectingOne,
    IconChromecastConnectingThree,
    IconChromecastConnectingTwo,
    IconChromecastDisconnected,
    IconCinemaModeExpand,
    IconCinemaModeMinimize,
    IconClear,
    IconCode,
    IconCollaborativePlaylist,
    IconCollection,
    IconCollectionActive,
    IconConnectToDevices,
    IconCopy,
    IconCopyAlt,
    IconDelete,
    IconDestinationPin,
    IconDeviceArm,
    IconDeviceCar,
    IconDeviceCarExit,
    IconDeviceComputer,
    IconDeviceMobile,
    IconDeviceMultispeaker,
    IconDeviceOther,
    IconDevices,
    IconDevicesAlt,
    IconDeviceSpeaker,
    IconDeviceTablet,
    IconDeviceTv,
    IconDiscover,
    IconDownload,
    IconDownloaded,
    IconDraft,
    IconDragAndDrop,
    IconEdit,
    IconEmail,
    IconEnhance,
    IconEnhanceActive,
    IconEnhanceBadge,
    IconEvents,
    IconExclamationAltActive,
    IconExclamationCircle,
    IconExternalLink,
    IconFacebook,
    IconFacebookMessenger,
    IconFilter,
    IconFlag,
    IconFolder,
    IconFolderActive,
    IconFollow,
    IconFollowActive,
    IconFullscreen,
    IconGamesConsole,
    IconGears,
    IconGem,
    IconGithub,
    IconGoogle,
    IconGridView,
    IconGroup,
    IconGroupActive,
    IconHash,
    IconHeadphones,
    IconHeart,
    IconHeartActive,
    IconHelpAltActive,
    IconHelpCircle,
    IconHidden,
    IconHome,
    IconHomeActive,
    IconImage,
    IconInbox,
    IconInformationAlt,
    IconInformationAltActive,
    IconInstagram,
    IconInvite,
    IconLab,
    IconLightning,
    IconLineMessenger,
    IconListView,
    IconLocalFile,
    IconLocked,
    IconLockedActive,
    IconLyrics,
    IconLyricsActive,
    IconMakeAvailableOffline,
    IconMeAlt,
    IconMeAltActive,
    IconMenu,
    IconMessages,
    IconMic,
    IconMicActive,
    IconMicOff,
    IconMinimize,
    IconMinus,
    IconMinusAltActive,
    IconMix,
    IconMore,
    IconMoreAlt,
    IconMoreAltActive,
    IconMoreAndroid,
    IconNewRadio,
    IconNikePlus,
    IconNotificationNew,
    IconNotifications,
    IconNotificationsActive,
    IconNowPlaying,
    IconNowPlayingActive,
    IconOffline,
    IconOfflineSync,
    IconPause,
    IconPauseAlt,
    IconPauseAltActive,
    IconPayment,
    IconPictureInPicture,
    IconPin,
    IconPinActive,
    IconPlay,
    IconPlayAlt,
    IconPlayAltActive,
    IconPlaybackSpeed0point5x,
    IconPlaybackSpeed0point8x,
    IconPlaybackSpeed1point2x,
    IconPlaybackSpeed1point5x,
    IconPlaybackSpeed1Point8x,
    IconPlaybackSpeed1x,
    IconPlaybackSpeed2Point5x,
    IconPlaybackSpeed2x,
    IconPlaybackSpeed3Point5x,
    IconPlaybackSpeed3x,
    IconPlaylist,
    IconPlus,
    IconPlusAlt,
    IconPlusAltActive,
    IconPodcastCreator,
    IconPodcasts,
    IconPodcastsActive,
    IconPower,
    IconPreview,
    IconPublic,
    IconQueue,
    IconRadio,
    IconRadioActive,
    IconRaisedHand,
    IconReact,
    IconReceipt,
    IconRecentlyPlayed,
    IconRefresh,
    IconReleased,
    IconRepeat,
    IconRepeatOnce,
    IconReplay,
    IconReportAbuse,
    IconRoyalties,
    IconRoyaltiesActive,
    IconSearch,
    IconSearchActive,
    IconShareAndroid,
    IconShareIos,
    IconShuffle,
    IconSkipBack,
    IconSkipBack15,
    IconSkipBackAlt,
    IconSkipForward,
    IconSkipForward15,
    IconSkipForwardAlt,
    IconSkype,
    IconSleepTimer,
    IconSongCredits,
    IconSort,
    IconSortBy,
    IconSortDown,
    IconSortUp,
    IconSoundwave,
    IconSpeechBubble,
    IconSpotifyConnect,
    IconSpotifyLogo,
    IconStar,
    IconStarAlt,
    IconStations,
    IconSubtitles,
    IconTag,
    IconTalkSegment,
    IconTelegram,
    IconTextBold,
    IconTextItalic,
    IconTextUnderline,
    IconThumbsDown,
    IconThumbsDownActive,
    IconThumbsUp,
    IconThumbsUpActive,
    IconTiktok,
    IconTime,
    IconTimeActive,
    IconTrack,
    IconTranslation,
    IconTranslationActive,
    IconTrending,
    IconTrendingActive,
    IconTrim,
    IconTumblr,
    IconTwitter,
    IconUndo,
    IconUnlocked,
    IconUploadAlt,
    IconUploadAltActive,
    IconUser,
    IconUserActive,
    IconUserCircle,
    IconVerified,
    IconVerifiedCheck,
    IconVerifiedCheckActive,
    IconVideo,
    IconVideoVertical,
    IconVolume,
    IconVolumeDown,
    IconVolumeDownActive,
    IconVolumeOff,
    IconVolumeOffActive,
    IconVolumeOneWave,
    IconVolumeTwoWave,
    IconVolumeUp,
    IconVolumeUpActive,
    IconWatch,
    IconWatchDownload,
    IconWhatsApp,
    IconWifi,
    IconX,
    IconXAlt,
};
//# sourceMappingURL=Icons.js.map